import { Collection } from 'modules/core/lib/mobx-rest'

import TemplateQuestion from 'modules/surveys/store/models/TemplateQuestion'

class TemplateQuestions extends Collection<TemplateQuestion> {
  get cacheKey(): string {
    return 'surveysTemplateQuestions'
  }
  model() {
    return TemplateQuestion
  }
}

const templateQuestions: TemplateQuestions = new TemplateQuestions()

export default templateQuestions
